import styled from 'styled-components'
import {blueColor, screenS} from '@theme/vars'

export const DeleteButtonWrapper = styled.div`
  display: flex;
  position: absolute;
  left: 330px;
  top: 43px;
`

export const ConfirmationTextWrapper = styled.div`
  text-align: center;
  margin-bottom: 10px;
`

export const ImagesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  height: auto;
  justify-content: center;
  margin-top: 16px;
`

export const MobileImageWrapper = styled.div`
  width: 360px;
  height: 208px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`

export const ImageForPCWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-self: flex-start;
  margin-left: 24px;

  width: 360px;
  height: 208px;

  @media screen and (max-width: 654px) {
    display: column;
    margin-top: 24px;
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  margin-top: 12px;
`

export const ViewSourceImageWrapper = styled.a`
  color: ${blueColor};
  margin-top: 0px;
  text-decoration: underline;

  & :hover {
    cursor: pointer;
  }
`

export const GalleryBlockInfoFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  width: 460px;

  @media screen and (max-width: ${screenS}) {
    width: 100%;
    margin-top: 20px;
    margin-left: 0px;
  }
`
